// extracted by mini-css-extract-plugin
export default {"choiceBuyer":"p6z6BZ","choiceBuyerTitle":"PddmJT","bottomOfCard":"BupKZW","text":"Mzhoku","soldButtons":"a3si6X","actionButton":"hUj5x3","commission":"ui8GAB"};